export default __webpack_public_path__ + "static/media/slide2.fec4ae55.JPG";